import { FC } from 'react';
import { Edit, EditProps, required, SimpleForm, TextInput } from 'react-admin';
import HardwareCompatibilityInput from './HardwareCompatibilityInput';

export const SoftwareComponentEdit: FC<EditProps> = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="path" />
      <TextInput
        source="build_project_name"
        helperText="Leave empty for conventional components (GitLab project systems/tover.X resolves to tover.X automatically). Set only for legacy/irregular build projects (e.g. tovertafel, telekinesis, tovertafel-updater)."
      />
      <HardwareCompatibilityInput />
    </SimpleForm>
  </Edit>
);
